import React, { useEffect, useState } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import {
  Row,
  Col,
  theme as themeConfig,
  Tag,
  Input,
  Button,
  message,
} from "antd"
import { SearchOutlined } from "@ant-design/icons"

import { updatePageState } from "../../../../data/redux/page_details/actions"
import { APP_PAGES } from "../../../../data/constants/layout"

import { updateCampaignAnalyticsState } from "../../../../data/redux/campaign_analytics_details/actions"

import LiveMetrics from "./LiveMetrics"
import Metrics from "./Metrics"

const CampaignAnalytics = ({
  actions,
  selectedCampaignIds,
  cLoading,
  hLoading,
  sLoading,
}) => {
  const { token } = themeConfig.useToken()
  const { updatePageState, updateCampaignAnalyticsState } = actions

  const [campaignId, setCampaignId] = useState("")

  useEffect(() => {
    document.title = APP_PAGES.CAMPAIGN_ANALYTICS
    updatePageState({
      current_page: APP_PAGES.CAMPAIGN_ANALYTICS,
      current_sider_module: APP_PAGES.CAMPAIGN_ANALYTICS,
    })
  }, [updatePageState])

  useEffect(() => {
    return () => {
      updateCampaignAnalyticsState({
        selectedCampaignIds: [],
      })
    }
  }, [])

  const handleOnSubmitSearchKey = () => {
    if (campaignId.trim()) {
      if (selectedCampaignIds.includes(campaignId.trim())) {
        message.info(`Campaign ID "${campaignId.trim()}" is already selected`)
        return
      }

      const newIds = [...selectedCampaignIds, campaignId.trim()]
      updateCampaignAnalyticsState({ selectedCampaignIds: newIds })

      setCampaignId("")
    }
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            width: "60%",
            flex: "1 1 auto",
            marginRight: token.marginMD,
          }}
        >
          {selectedCampaignIds &&
            selectedCampaignIds.map(id => (
              <Tag
                key={id}
                style={{
                  marginBottom: token.marginXS,
                }}
                size="medium"
                color="green"
                closable
                onClose={() => {
                  const newIds = selectedCampaignIds.filter(cid => cid !== id)
                  updateCampaignAnalyticsState({ selectedCampaignIds: newIds })
                }}
              >
                {id}
              </Tag>
            ))}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            flex: "0 0 auto",
            marginLeft: "auto",
          }}
        >
          <Input
            disabled={cLoading || hLoading || sLoading}
            placeholder="Search by Campaign ID"
            style={{
              width: "280px",
            }}
            prefix={<SearchOutlined />}
            value={campaignId}
            onChange={e => setCampaignId(e.target.value)}
            onPressEnter={handleOnSubmitSearchKey}
            allowClear
          />
          <Button
            disabled={!campaignId.trim()}
            loading={cLoading || hLoading || sLoading}
            style={{
              marginLeft: token.marginXS,
            }}
            type="primary"
            onClick={handleOnSubmitSearchKey}
          >
            Search
          </Button>
        </div>
      </div>

      <Row gutter={[8, 10]}>
        <Col span={24}>
          <LiveMetrics />
        </Col>
        <Col span={24}>
          <Metrics />
        </Col>
      </Row>
    </div>
  )
}

const mapStateToProps = state => ({
  selectedCampaignIds: state.campaigns_analytics_details.selectedCampaignIds,
  cLoading: state.campaigns_analytics_details.cLoading,
  hLoading: state.campaigns_analytics_details.hLoading,
  sLoading: state.campaigns_analytics_details.sLoading,
})

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        updatePageState,
        updateCampaignAnalyticsState,
      },
      dispatch
    ),
  }
}

CampaignAnalytics.defaultProps = {
  selectedCampaignIds: [],
  cLoading: false,
  hLoading: false,
  sLoading: false,
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignAnalytics)
